<div class="questionnaire-history-detail">
  <div class="detail-header">
    <div class="detail-header-title">
      {{ getQuestionnaireTitle() }}
    </div>
    <button nz-button nzType="default" type="button" (click)="backToHistory()">
      <nz-icon nzType="arrow-left" nzTheme="outline" />
      <span>{{ "Back" | translate }}</span>
    </button>
  </div>

  @if (isLoading) {
    <div class="detail-state">
      <nz-spin [nzSpinning]="true" nzSize="large"></nz-spin>
    </div>
  }

  @if (!isLoading && error) {
    <div class="detail-state detail-error">
      {{ error }}
    </div>
  }

  @if (!isLoading && !error && canRenderQuestionnaireScreen()) {
    @if (shouldShowSummary()) {
      <div class="detail-summary">
        <div class="summary-card">
          <span class="summary-label">{{ "Status" | translate }}</span>
          <span class="summary-value">{{ getStatus() }}</span>
        </div>
        <div class="summary-card">
          <span class="summary-label">{{ "Visit / Episode" | translate }}</span>
          <span class="summary-value">{{ getVisitContext() }}</span>
        </div>
        <div class="summary-card">
          <span class="summary-label">{{ "Created date" | translate }}</span>
          <span class="summary-value">{{ getCreatedDate() }}</span>
        </div>
        <div class="summary-card">
          <span class="summary-label">{{ "Submitted" | translate }}</span>
          <span class="summary-value">{{ getSubmittedDate() }}</span>
        </div>
        <div class="summary-card">
          <span class="summary-label">{{ "Submitted by" | translate }}</span>
          <span class="summary-value">{{ getActor() }}</span>
        </div>
        @if (shouldShowScoreSummary()) {
          <div class="summary-card">
            <span class="summary-label">{{ "Score" | translate }}</span>
            <span class="summary-value">{{ getScoreSummary() }}</span>
          </div>
        }
      </div>
    }

    @if (questionnaireTemplateId === 1) {
      <app-dynamic-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 2) {
      <app-fast-protocol-mediterranean-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 3) {
      <app-stroke-score-mediterranean-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 4) {
      <app-speech-therapy-pd-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 5) {
      <app-speech-therapy-gds-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 6) {
      <app-speech-therapy-bdi-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 7) {
      <app-speech-therapy-ocad-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 8) {
      <app-physiotherapy-berg-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 9) {
      <app-physiotherapy-pac-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 10) {
      <app-sldc-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 11) {
      <app-slag-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 12) {
      <app-dn4-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 13) {
      <app-eq5d-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 14) {
      <app-mobid-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 15) {
      <app-painad-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 16) {
      <app-pacslac2-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
  }
</div>
